// practitioner-edit-dialog.component.ts
import { Component, Inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatButtonModule } from '@angular/material/button';

export interface PractitionerEditDialogData {
  firstName?: string;
  lastName?: string;
  phoneNumber?: string;
  gender?: string;
  birthDate?: string; // 'YYYY-MM-DD'
  addressLine?: string;
  city?: string;
  state?: string;
  postalCode?: string;
  country?: string;
}

@Component({
  selector: 'app-practitioner-edit-dialog',
  standalone: true,
  imports: [
    CommonModule, ReactiveFormsModule, MatDialogModule,
    MatFormFieldModule, MatInputModule, MatSelectModule, MatButtonModule
  ],
  template: `
    <h2 mat-dialog-title>Edit Practitioner</h2>
    <form [formGroup]="form" (ngSubmit)="onSave()">
      <div mat-dialog-content>
        <mat-form-field appearance="outline" class="full-width">
          <mat-label>First Name</mat-label>
          <input matInput formControlName="firstName" required />
        </mat-form-field>

        <mat-form-field appearance="outline" class="full-width">
          <mat-label>Last Name</mat-label>
          <input matInput formControlName="lastName" required />
        </mat-form-field>

        <mat-form-field appearance="outline" class="full-width">
          <mat-label>Phone Number</mat-label>
          <input matInput formControlName="phoneNumber" />
        </mat-form-field>


        <mat-form-field appearance="outline" class="full-width">
          <mat-label>Gender</mat-label>
          <mat-select formControlName="gender">
            <mat-option value="male">Male</mat-option>
            <mat-option value="female">Female</mat-option>
            <mat-option value="other">Other</mat-option>
            <mat-option value="unknown">Unknown</mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field appearance="outline" class="full-width">
          <mat-label>Date of Birth</mat-label>
          <input matInput type="date" formControlName="birthDate" />
        </mat-form-field>

        <mat-form-field appearance="outline" class="full-width">
          <mat-label>Address Line</mat-label>
          <input matInput formControlName="addressLine" />
        </mat-form-field>

        <mat-form-field appearance="outline" class="full-width">
          <mat-label>City</mat-label>
          <input matInput formControlName="city" />
        </mat-form-field>

        <mat-form-field appearance="outline" class="full-width">
          <mat-label>State</mat-label>
          <input matInput formControlName="state" />
        </mat-form-field>

        <mat-form-field appearance="outline" class="full-width">
          <mat-label>Postal Code</mat-label>
          <input matInput formControlName="postalCode" />
        </mat-form-field>

        <mat-form-field appearance="outline" class="full-width">
          <mat-label>Country</mat-label>
          <input matInput formControlName="country" />
        </mat-form-field>
      </div>

      <div mat-dialog-actions align="end">
        <button mat-button type="button" (click)="dialogRef.close()">Cancel</button>
        <button mat-flat-button color="primary" type="submit" [disabled]="form.invalid">Save</button>
      </div>
    </form>
  `,
  styles: [`.full-width { width: 100%; margin-bottom: 8px; }`]
})
export class PractitionerEditDialogComponent {
  form: FormGroup;

  constructor(
    public dialogRef: MatDialogRef<PractitionerEditDialogComponent>,
    private fb: FormBuilder,
    @Inject(MAT_DIALOG_DATA) public data: PractitionerEditDialogData
  ) {
    this.form = this.fb.group({
      firstName: [data.firstName || '', Validators.required],
      lastName: [data.lastName || '', Validators.required],
      phoneNumber: [data.phoneNumber || ''],
      gender: [data.gender || ''],
      birthDate: [data.birthDate || ''],
      addressLine: [data.addressLine || ''],
      city: [data.city || ''],
      state: [data.state || ''],
      postalCode: [data.postalCode || ''],
      country: [data.country || '']
    });
  }

  onSave(): void {
    if (this.form.invalid) return;
    this.dialogRef.close({ updated: true, ...this.form.value });
  }
}